export default {
    current_choice: '目前的选择',
    book_now: '立即预订',
    minimum_age: '超过{age}的唯一',
    excess_liability: '超额责任',
    security_deposit: '保证金',
    fuel_policy: '燃油政策',
    like_for_like: '喜欢又喜欢',
    full_to_full: '满到满',
    miles_per_rental: '{mileage} 每次租赁免费里程',
    km_per_rental: '{mileage} 每次租赁免费公里数',
    unlimited_mileage: '不限里程',
    unlimited_mileage_km: '无限公里',
    non_amendable: '不可修改',
    non_refundable: '不退还',
    free_cancellation_until: '免费取消直至',
    basic_free_cancellation: '开始时间前最多48小时可免费取消',
    cancellation_in_line_with: '取消符合',
    tcs: 'T&amp;Cs',
    free_extras_on_collection: '收藏时可免费获得两项额外奖励',
    glass_and_tyres_covered: '玻璃和轮胎被覆盖',
    number_of_passengers: '乘客人数',
    number_of_bags: '袋数',
    fuel_type: '燃料类型',
    co2: 'CO2',
    aircon: '空调',
    transmission: '传播',
    book_type: '书{type}',
    debit_card_deposit: '接受借记卡存款',
    fast_track_included: '包含快速通道',
    view_all: '查看全部',
}
